import { createCRUDHook } from './createCRUDHook';
import { ContactUsDto } from 'utils/models';
import { ECG_CONTACTUS } from './apiEndPoints';

const { Context, useManager, useConsumer } = createCRUDHook<ContactUsDto>({
  entityName: 'ContactUs',
  endpoint: ECG_CONTACTUS,
});

export const ContactUsContext = Context;
export const useContactUsManager = useManager;
export const useContactUs = useConsumer;
